/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";a[_ngcontent-%COMP%]{border-radius:15px;color:#a5acb0!important;background:0 0;border:none;font-size:25pt;cursor:pointer;padding:0}a[_ngcontent-%COMP%]:before{font-family:simple-line-icons;content:\"\uE07A\"}"];
export { styles as styles };
